export default __webpack_public_path__ + "images/0x00a35fd824c717879bf370e70ac6868b95870dfb.png";